import { render, staticRenderFns } from "./GiftSubBatches.vue?vue&type=template&id=5b0ae031&scoped=true&"
import script from "./GiftSubBatches.vue?vue&type=script&lang=js&"
export * from "./GiftSubBatches.vue?vue&type=script&lang=js&"
import style0 from "./GiftSubBatches.vue?vue&type=style&index=0&id=5b0ae031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ae031",
  null
  
)

component.options.__file = "GiftSubBatches.vue"
export default component.exports